<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method={method}>
        <div class="form-group">
            <label for="usernameInput">Username</label>
            <input type="text" class="form-control" name="username" id="usernameInput" required="" />
            <div class="invalid-feedback">Please enter your username or email</div>
        </div>
        <div class="form-group">
            <label for="passwordInput">Password</label>
            <input type="password" class="form-control" name="password" id="passwordInput" required="" autoComplete="new-password" />
            <div class="invalid-feedback">Please enter a password</div>
        </div>
        <div v-if="showRememberMe" class="form-check small">
            <label class="form-check-label">
                <input type="checkbox" class="form-check-input" name="rememberInput" id="rememberInput" /> <span>{{ rememberMeLabel }}</span>
            </label>
        </div>
        <button type="submit" class="btn btn-primary btn-lg float-right" id="loginBtn">{{ submitBtnText }}</button>
    </form>
</template>
<script>
export default {
    props: {
        showRememberMe: false,
        rememberMeLabel: "Remember me",
        submitBtnText: {
            type: String,
            default: "Login"            
        }
    }
};
</script>
